import { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [portalToken, setPortalToken] = useState(() => localStorage.getItem("portal_token"));
  const [adminToken, setAdminToken] = useState(() => localStorage.getItem("admin_token"));

  const loginPortal = (token) => {
    localStorage.setItem("portal_token", token);
    setPortalToken(token);
  };
  const logoutPortal = () => {
    localStorage.removeItem("portal_token");
    setPortalToken(null);
  };
  const loginAdmin = (token) => {
    localStorage.setItem("admin_token", token);
    setAdminToken(token);
  };
  const logoutAdmin = () => {
    localStorage.removeItem("admin_token");
    setAdminToken(null);
  };

  return (
    <AuthContext.Provider value={{ portalToken, adminToken, loginPortal, logoutPortal, loginAdmin, logoutAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
